<template>
  <div>
    <v-card color="background" flat>
      <v-card-subtitle class="px-0 pb-0 caption">
        NUEVO CONTRATO
      </v-card-subtitle>

      <v-card-title class="px-0 pt-0">
        Completá el plan de pago
      </v-card-title>

      <v-card-subtitle class="px-0 pb-1 caption"> </v-card-subtitle>
    </v-card>
    <v-card>
      <v-card-text>
        <div class="pb-6">
          <v-form lazy-validation v-model="valid" ref="description">
            <v-row>
              <v-col class="pb-0" cols="12">
                <div class="caption">
                  Locador(es)
                </div>
              </v-col>
              <v-col
                class="pt-0 title font-weight-regular black--text"
                cols="12"
              >
                <div>
                  {{
                    fetchedContract.owner.map(o => o.profile.name).join(", ")
                  }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :rules="rules"
                  :items="contacts"
                  item-text="profile.name"
                  item-value="id"
                  v-model="contract.tenant_id"
                  filled
                  hint="*Obligatorio"
                  persistent-hint
                  label="Locatario"
                >
                </v-autocomplete>
              </v-col>

              <v-col class="mt-3" cols="6">
                <Modal
                  ref="modal"
                  text="Agregar a agenda"
                  color="blue lighten-1"
                  :button_text="true"
                >
                  <NewContact
                    @close="$refs.modal.dialog = false"
                    @created="onCreate"
                  />
                </Modal>
              </v-col>
            </v-row>
            <div class="title black--text font-weight-regular">
              Duración
            </div>
            <v-row>
              <v-col cols="3">
                <v-menu
                  v-model="startMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="contract.attributes.startsAt"
                      :rules="rules"
                      label="Inicio"
                      append-icon="mdi-calendar-blank"
                      readonly
                      filled
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="contract.attributes.startsAt"
                    @input="startMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-menu
                  v-model="endMenu"
                  :disabled="!contract.attributes.startsAt"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :rules="rules"
                      v-model="contract.attributes.endsAt"
                      :disabled="!contract.attributes.startsAt"
                      label="Fin"
                      append-icon="mdi-calendar-blank"
                      readonly
                      filled
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="contract.attributes.endsAt"
                    :min="new Date().toISOString().substr(0, 10)"
                    @input="endMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="3">
                <v-checkbox
                  class="mt-1"
                  label="Aumento según nueva ley"
                  v-model="contract.attributes.newLaw"
                  hide-details
                >
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-checkbox
                  label="Alquiler en dólares"
                  v-model="contract.attributes.dollarized"
                  hide-details
                >
                </v-checkbox>
              </v-col>

              <v-col cols="6">
                <v-checkbox
                  label="Transferencia directa al locador"
                  v-model="contract.attributes.thirdPartyTransfer"
                  hint="¿El locatario realiza el pago del alquiler por transferencia directa al locador?"
                  persistent-hint
                >
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-autocomplete
                  :rules="rules"
                  :items="contractSplitOptions"
                  :disabled="
                    !contract.attributes.startsAt || !contract.attributes.endsAt
                  "
                  v-model="
                    contract.attributes.paymentPlanAttributes.taxesAttributes.find(
                      el => el.name == 'Alquiler'
                    ).interval
                  "
                  filled
                  hint="*Obligatorio"
                  persistent-hint
                  label="Divisible en"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  :rules="rules"
                  v-model="
                    contract.attributes.paymentPlanAttributes.taxesAttributes.find(
                      el => el.name == 'Alquiler'
                    ).commission
                  "
                  filled
                  hint="% del cobro de alquiler"
                  placeholder="10"
                  suffix="%"
                  persistent-hint
                  label="Honorarios Administración Inmobiliaria"
                >
                </v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  :rules="rules"
                  v-model="
                    contract.attributes.paymentPlanAttributes.taxesAttributes.find(
                      el => el.name == 'Alquiler'
                    ).chargeback
                  "
                  filled
                  hint="% de recargo diario"
                  placeholder="10"
                  suffix="%"
                  persistent-hint
                  label="Recargos por mora"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <div class="title black--text font-weight-regular">
              Periodos
            </div>
            <div v-if="rentPrices.length">
              <v-row v-if="!price._destroy" v-for="(price, idx) in rentPrices">
                <v-col class="pt-0 pr-0" cols="3">
                  <v-text-field
                    filled
                    :hint="
                      contractSplit +
                        (contractSplit == 1 ? ' mes' : ' meses') +
                        ': ' +
                        price.startsAt.toLocaleDateString('es') +
                        ' hasta ' +
                        price.endsAt.toLocaleDateString('es')
                    "
                    persistent-hint
                    :label="'Periodo ' + (idx + 1)"
                    v-model="price.amount"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="pt-0" cols="3">
                  <v-text-field
                    filled
                    :label="'Pagaré'"
                    v-model="price.differential"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0" cols="6">
                  <v-text-field
                    filled
                    disabled
                    label="Total contrato"
                    :value="sumRent"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <div class="title black--text font-weight-regular pb-3">
                Honorarios alquiler locatario
              </div>

              <v-row>
                <v-col class="pt-0 pr-0" cols="2">
                  <v-text-field
                    filled
                    hide-details
                    label="Honorarios"
                    v-model="fee"
                    placeholder="20000"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="pt-0" cols="2">
                  <v-text-field
                    filled
                    hide-details
                    label="Cuotas"
                    v-model="feeSplit"
                    placeholder="6"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="pt-0 pl-0" cols="2">
                  <v-text-field
                    filled
                    hide-details
                    label="Intereses"
                    v-model="feeCharge"
                    placeholder="0"
                    suffix="%"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  v-if="
                    contract.attributes.paymentPlanAttributes.taxesAttributes.find(
                      t => t.name == 'Honorarios'
                    ).pricesAttributes[0]
                  "
                  class="pt-0"
                  cols="6"
                >
                  <v-text-field
                    filled
                    disabled
                    hide-details
                    label="Valor cuota"
                    v-model="
                      contract.attributes.paymentPlanAttributes.taxesAttributes.find(
                        t => t.name == 'Honorarios'
                      ).pricesAttributes[0].amount
                    "
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pt-0" cols="6">
                  <v-checkbox
                    hide-details
                    label="El Locador paga parte de los honorarios"
                    v-model="displayOwnerFee"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>

              <v-row v-if="displayOwnerFee">
                <v-col class="pt-0 pr-0" cols="2">
                  <v-text-field
                    filled
                    hide-details
                    label="Porcentaje"
                    v-model="
                      contract.attributes.paymentPlanAttributes.taxesAttributes.find(
                        t => t.name == 'Honorarios'
                      ).ownerFee
                    "
                    placeholder="0"
                    suffix="%"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <div class="title black--text font-weight-regular pt-3">
                Formas de pago
              </div>

              <v-row v-for="pm in ['Transferencia', 'Efectivo', 'Cheque']">
                <v-col class="py-0" cols="6">
                  <v-checkbox
                    filled
                    hide-details
                    :label="pm"
                    :value="pm"
                    v-model="
                      contract.attributes.paymentPlanAttributes.paymentMethods
                    "
                  >
                  </v-checkbox>
                </v-col>
              </v-row>

              <div class="title black--text font-weight-regular py-3">
                Entrega
              </div>

              <v-row>
                <v-col class="py-0" cols="6">
                  <v-text-field
                    filled
                    hide-details
                    label="Número de llaves"
                    v-model="contract.attributes.keys"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </div>

            <div v-else>
              <v-card flat class="grey lighten-3" rounded="lg">
                <v-card-text
                  class="text--primary d-flex align-center"
                  style="gap: 8px"
                >
                  <div>
                    <v-icon class="mt-n1" color="info">mdi-information</v-icon>
                  </div>

                  <div>
                    Para visualizar los períodos deberá cargar previamente la
                    duración del contrato (fecha de inicio, fecha de fin y campo
                    "divisible en").
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
    <div class="pt-6 text-right">
      <v-btn @click="$router.go(-1)" text>
        Cerrar y continuar luego
      </v-btn>
      <v-btn color="primary" @click="nextStep">
        Siguiente
      </v-btn>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/modals/Default";
import NewContact from "@/components/directories/New";
import { Contacts } from "@/graphql/queries/directory";
import { EditContract } from "@/graphql/mutations/contracts";

export default {
  data() {
    return {
      loading: false,
      valid: true,
      startMenu: false,
      endMenu: false,
      fee: null,
      feeSplit: null,
      feeCharge: 0,
      displayOwnerFee: false,
      contract: {
        tenant_id: null,
        attributes: {
          newLaw: false,
          dollarized: false,
          thirdPartyTransfer: false,
          startsAt: null,
          endsAt: null,
          keys: 0,
          paymentPlanAttributes: {
            paymentMethods: [],
            taxesAttributes: [
              {
                name: "Alquiler",
                chargeback: 0,
                startsAt: null,
                endsAt: null,
                interval: null,
                state: "ongoing",
                pricesAttributes: []
              },
              {
                name: "Honorarios",
                ownerFee: 0,
                startsAt: null,
                endsAt: null,
                interval: 1,
                state: "ongoing",
                pricesAttributes: [
                  {
                    amount: 0,
                    startsAt: null,
                    endsAt: null
                  }
                ]
              }
            ]
          }
        }
      },
      contractSplitOptions: [
        {
          text: "Mensual",
          value: 1
        },
        {
          text: "Bimestral",
          value: 2
        },
        {
          text: "Trimestral",
          value: 3
        },
        {
          text: "Cuatrimestral",
          value: 4
        },
        {
          text: "Semestral",
          value: 6
        },
        {
          text: "Anual",
          value: 12
        }
      ],
      resetSplit: null,
      periods: null,
      rules: [v => !!v || "*Obligatorio"],
      contacts: []
    };
  },

  components: {
    Modal,
    NewContact
  },

  props: {
    fetchedContract: {
      type: Object,
      required: true
    }
  },

  mounted() {
    this.fetchContacts(true);
  },

  watch: {
    "contract.attributes.newLaw": {
      handler(value) {
        if (value) {
          this.contract.attributes.startsAt =
            this.contract.attributes.startsAt ||
            new Date().toISOString().substring(0, 10);

          let tax = this.contract.attributes.paymentPlanAttributes.taxesAttributes.find(
            el => el.name == "Alquiler"
          );
          let startsAt = new Date(this.contract.attributes.startsAt);
          var endsAt = new Date(
            startsAt.getFullYear() + 3,
            startsAt.getMonth(),
            startsAt.getDate()
          );
          this.contract.attributes.endsAt = endsAt
            .toISOString()
            .substring(0, 10);

          tax.interval = tax.interval == 6 ? tax.interval : 12;

          this.contractSplitOptions = [
            {
              text: "Semestral",
              value: 6
            },
            {
              text: "Anual",
              value: 12
            }
          ];
          this.$forceUpdate();
        } else {
          this.contractSplitOptions = [
            {
              text: "Mensual",
              value: 1
            },
            {
              text: "Bimestral",
              value: 2
            },
            {
              text: "Trimestral",
              value: 3
            },
            {
              text: "Cuatrimestral",
              value: 4
            },
            {
              text: "Semestral",
              value: 6
            },
            {
              text: "Anual",
              value: 12
            }
          ];
        }
      }
    },

    valid(newVal) {
      if (!newVal) {
        this.$vuetify.goTo(0);
      }
    },

    "contract.attributes.startsAt": {
      handler(val) {
        if (this.contract.attributes.paymentPlanAttributes) {
          this.rentSplit = null;
          this.contract.attributes.paymentPlanAttributes.taxesAttributes.find(
            x => x.name === "Alquiler"
          ).startsAt = val;
        }
      }
    },

    "contract.attributes.endsAt": {
      handler(val) {
        if (this.contract.attributes.paymentPlanAttributes) {
          this.rentSplit = null;
          this.contract.attributes.paymentPlanAttributes.taxesAttributes.find(
            x => x.name === "Alquiler"
          ).endsAt = val;
        }
      }
    },

    feeChange: {
      handler(val) {
        if (this.fee && this.feeSplit) {
          let tax = this.contract.attributes.paymentPlanAttributes.taxesAttributes.find(
            x => x.name === "Honorarios"
          );
          let prices = tax.pricesAttributes;
          let amount = Math.ceil(this.fee / this.feeSplit);

          if (this.feeCharge) {
            amount += Math.ceil((amount * this.feeCharge) / 100);
          }
          var lastDate = new Date(this.contract.startsAt);

          for (let i = 0; i < this.feeSplit; i++) {
            let price = prices[i];
            let startsAt = lastDate;
            let endsAt = new Date(
              startsAt.getFullYear(),
              startsAt.getMonth() + 1,
              startsAt.getDate()
            );
            lastDate = new Date(
              startsAt.getFullYear(),
              startsAt.getMonth() + 1,
              startsAt.getDate()
            );

            if (price) {
              price.amount = amount;
              price.startsAt = startsAt;
              price.endsAt = endsAt;
            } else {
              prices.push({
                amount: amount,
                differential: 0,
                startsAt: startsAt,
                endsAt: endsAt
              });
            }
          }

          for (var i = this.feeSplit; i < prices.length; i++) {
            prices[i]._destroy = true;
          }
        }
      }
    },

    dateFields(val) {
      let tax = this.contract.attributes.paymentPlanAttributes.taxesAttributes.find(
        x => x.name === "Alquiler"
      );

      if (this.contractSplit && this.contractSplit != this.rentSplit) {
        var prices = tax.pricesAttributes;

        var months;
        var dateFrom = new Date(this.contract.attributes.startsAt);
        var dateTo = new Date(this.contract.attributes.endsAt);
        months =
          dateTo.getMonth() -
          dateFrom.getMonth() +
          12 * (dateTo.getFullYear() - dateFrom.getFullYear());
        this.periods = Math.ceil(months / this.contractSplit);

        for (var i = 1; i <= this.periods; i++) {
          let auxDate = new Date(dateFrom);
          let auxTo = new Date(dateTo);
          var startsAt = new Date(
            auxDate.setMonth(auxDate.getMonth() + (i - 1) * this.contractSplit)
          );
          var endsAt = new Date(
            startsAt.getFullYear(),
            startsAt.getMonth() + this.contractSplit,
            startsAt.getDate() + 1
          );

          if (i == this.periods) {
            endsAt = auxTo;
          }

          startsAt.setHours(startsAt.getHours() + 3);

          let price = prices[i - 1];

          if (price) {
            price.startsAt = startsAt;
            price.endsAt = endsAt;
            delete price._destroy;
          } else {
            prices.push({
              amount: 0,
              differential: 0,
              startsAt: startsAt,
              endsAt: endsAt
            });
          }
        }

        for (var i = this.periods; i < prices.length; i++) {
          prices[i]._destroy = true;
        }
      }
    }
  },

  computed: {
    referrals() {
      if (!this.contract) return [];
      let property =
        this.object == "Property" ? this.contract : this.contract.property;
      return [
        { text: "Locatario", value: this.contract.tenant_id },
        { text: "Locador", value: this.fetchedContract.owner[0].id }
      ];
    },

    dateFields() {
      return (
        this.contract.attributes.startsAt +
        this.contract.attributes.endsAt +
        this.contractSplit
      );
    },

    rentPrices() {
      if (this.contract.attributes.paymentPlanAttributes) {
        let newLaw = this.contract.attributes.newLaw;
        let prices = this.contract.attributes.paymentPlanAttributes.taxesAttributes.find(
          x => x.name === "Alquiler"
        ).pricesAttributes;
        let date = new Date();

        date.setMonth(date.getMonth() + 1);

        if (newLaw) {
          prices = prices.filter(price => price.startsAt < date);
        }

        return prices;
      } else {
        return [];
      }
    },

    sumRent() {
      var total = 0;

      if (this.contract.attributes.newLaw) {
        total = this.rentPrices[0].amount;
        total = total * 36;
      } else {
        this.rentPrices.forEach(price => {
          total += parseInt(price.amount || 0);
        });
      }

      return total;
    },

    contractSplit() {
      return this.contract.attributes.paymentPlanAttributes.taxesAttributes.find(
        el => el.name == "Alquiler"
      ).interval;
    },

    feeChange() {
      return this.fee + this.feeSplit + this.feeCharge;
    }
  },

  methods: {
    onCreate(newOwner) {
      this.fetchContacts();
      this.contract.tenant_id = newOwner.id;
      this.$refs.modal.dialog = false;
    },

    nextStep() {
      this.editContract();
    },

    editContract() {
      if (this.valid) this.$refs.description.validate();

      if (this.valid) {
        this.$apollo
          .mutate({
            mutation: EditContract,
            variables: {
              input: {
                attributes: this.contract.attributes,
                tenantId: this.contract.tenant_id,
                contractId: this.fetchedContract.id
              }
            }
          })
          .then(res => {
            this.$emit("continue", res.data.editContract.contract);
          });
      }
    },

    fetchContacts(firstLoad = false) {
      this.$apollo
        .query({
          query: Contacts,
          variables: {
            noPaginate: true,
            userId: (this.fetchedContract.tenant[0] || {}).id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.contacts = res.data.contacts.contacts;
          if (firstLoad) {
            this.fillData();
          }
        });
    },

    fillData() {
      var aux = Object.assign({}, this.fetchedContract);
      aux.paymentPlanAttributes = aux.paymentPlan;
      delete aux.paymentPlan;
      this.deleteUnusedFields(aux);

      if (aux.paymentPlanAttributes && aux.paymentPlanAttributes.taxes) {
        delete aux.paymentPlanAttributes.__typename;
        aux.paymentPlanAttributes.taxesAttributes =
          aux.paymentPlanAttributes.taxes;
        delete aux.paymentPlanAttributes.taxes;
        aux.paymentPlanAttributes.taxesAttributes.forEach(tax => {
          tax.pricesAttributes = tax.prices;
          delete tax.prices;
          delete tax.__typename;

          tax.pricesAttributes.forEach(price => {
            delete price.__typename;
            if (price.startsAt) {
              var startsAt = new Date(price.startsAt);
              startsAt.setHours(startsAt.getHours() + 3);
              price.startsAt = startsAt;
            }

            if (price.endsAt) {
              var endsAt = new Date(price.endsAt);
              endsAt.setHours(endsAt.getHours() + 3);
              price.endsAt = endsAt;
            }
          });
        });

        this.contract.attributes = aux;
        this.contract.tenant_id = (this.fetchedContract.tenant[0] || {}).id;

        let tax = this.contract.attributes.paymentPlanAttributes.taxesAttributes.find(
          x => x.name === "Alquiler"
        );
        this.rentSplit = tax.interval;
        this.displayOwnerFee = !!tax.ownerFee;

        tax = this.contract.attributes.paymentPlanAttributes.taxesAttributes.find(
          x => x.name === "Honorarios"
        );

        if (!tax.pricesAttributes.length) {
          tax.pricesAttributes.push({
            amount: 0,
            differential: 0,
            startsAt: null,
            endsAt: null
          });
        }

        this.feeSplit = tax.pricesAttributes.length;

        let total = 0;

        tax.pricesAttributes.forEach(price => {
          total += parseInt(price.amount);
        });

        this.fee = total;
      }
    },

    deleteUnusedFields(contract) {
      delete contract.__typename;
      delete contract.taxes;
      delete contract.rent;
      delete contract.totalRentPrice;
      delete contract.duration;
      delete contract.guarantees;
      delete contract.contractPlan;
      delete contract.documents;
      delete contract.property;
      delete contract.owner;
      delete contract.tenant;
    }
  }
};
</script>
